import { createSelector } from 'reselect';
import { getEntry, getNotSetValue } from 'conversations-async-data/indexed-async-data/operators/getters';
import { getFilterRules } from './getFilterRules';
const getThreadIdFromProps = (_, {
  threadId
}) => threadId;
export const getAsyncFilterRulesByThreadId = createSelector([getFilterRules, getThreadIdFromProps], (filterRulesData, threadId) => threadId ? getEntry(threadId, filterRulesData) : getNotSetValue(filterRulesData));